import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../pages/buynowaddress/buynowaddress.css";
import { baseURL } from "../../constants/url";

const OrderSummaryCartDetails = ({
  selectedAddressId,
  cartItems = [],
  platformFee = 8.00,
  deliveryCharge = 49.00,
}) => {
  const [addressDetails, setAddressDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Calculate product total
  const productTotal = cartItems.reduce(
    (sum, item) =>
      sum + Number(item.final_price || 0) * Number(item.quantity || 0),
    0
  );

  // Final Total including fees
  const finalTotal = productTotal + platformFee + deliveryCharge;

  //  Load Razorpay
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    if (!selectedAddressId) {
      Swal.fire("Error", "Please select a delivery address!", "error");
      return;
    }

    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded) {
      Swal.fire("Error", "Razorpay SDK failed to load.", "error");
      return;
    }

    setIsLoading(true);

    try {
      const token = localStorage.getItem("authToken");

      const products = cartItems.map((item) => ({
        variant_id: item.product_variant_id,
        quantity: item.quantity,
      }));

      const response = await fetch(`${baseURL}common/create_order/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          products,
          address_id: selectedAddressId,
          platform_fee: platformFee,
          delivery_charge: deliveryCharge,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Order creation failed");
      }

      // IMPORTANT → use backend amount
      const options = {
        key: data.razorpay_key,
        amount: data.amount * 100,
        currency: data.currency || "INR",
        name: "My Shop",
        description: "Order Payment",
        order_id: data.order_id,
        handler: async function (response) {
          const verifyRes = await fetch(
            `${baseURL}common/verify_payment/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(response),
            }
          );

          if (verifyRes.ok) {
            Swal.fire("Success", "Payment Successful!", "success").then(() =>
              navigate("/ordersuccess")
            );
          } else {
            Swal.fire("Error", "Payment verification failed", "error");
          }
        },
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  //  Fetch Address
  useEffect(() => {
    const fetchAddress = async () => {
      if (!selectedAddressId) return;

      try {
        const token = localStorage.getItem("authToken");
        const res = await fetch(
          `${baseURL}common/addresses/${selectedAddressId}/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = await res.json();
        setAddressDetails(data);
      } catch (error) {
        console.error("Address fetch error:", error);
      }
    };

    fetchAddress();
  }, [selectedAddressId]);

  return (
    <div className="card_common mt_20">
      <h6>Order Summary</h6>

      {cartItems.map((item, index) => (
        <div key={index} className="product_detail_block pt_20 pb_20 border_bottom">
          <div className="grid_three_one">
            <div className="prduct_imgs">
              <img src={item.product_image} alt={item.product_name} />
            </div>
            <div className="prduct_detailss">
              <h6>{item.product_name}</h6>
              <p>₹{item.final_price}</p>
              <p>
                Quantity: {item.quantity} × ₹{item.final_price} = ₹
                {(item.final_price * item.quantity).toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      ))}

     
      <div className="mt_20 border_top_dash pt_15">
        <div className="d_flex justify_sp_between">
          <p>Products Total</p>
          <p>₹{productTotal.toFixed(2)}</p>
        </div>

        <div className="d_flex justify_sp_between">
          <p>Platform Fee</p>
          <p>₹{platformFee}</p>
        </div>

        <div className="d_flex justify_sp_between">
          <p>Delivery Charge</p>
          <p>₹{deliveryCharge}</p>
        </div>

        <div className="d_flex justify_sp_between font_bold pt_10">
          <p>Total Amount</p>
          <p>₹{finalTotal.toFixed(2)}</p>
        </div>
      </div>

      <div className="order_btn mt_20">
        <div className="d_flex justify_sp_end">
          <button
            className="saveForm"
            onClick={handlePayment}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Place Order"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSummaryCartDetails;
